//公告
const noticeBox          = () => import('@/components/notice/noticeBox');
const noticeList         = () => import('@/components/notice/noticeList');
const noticeInfo         = () => import('@/components/notice/noticeInfo');
const addNotice          = () => import('@/components/notice/notice/addNotice');
const editNotice         = () => import('@/components/notice/notice/editNotice');




export default{
    path: '/noticeBox',
    name: 'noticeBox',
    component: noticeBox,
    children: [
        { path: 'noticeList', component: noticeList, name: 'noticeList' },
        { path: 'noticeInfo', component: noticeInfo, name: 'noticeInfo' },
        { path: 'addNotice', component: addNotice, name: 'addNotice' },
        { path: 'editNotice', component: editNotice, name: 'editNotice' },
    ]
}



// WEBPACK FOOTER //
// ./src/router/routes/notice.js